export default __webpack_public_path__ + "static/media/iconCenterGPSBlack.298a9743.svg";